export const updateAuthStateAction = (state, data) => {
  return {
    ...state,
    ...data
  }
}

export const updateProfileAction = (state, data) => {
  return {
    ...state,
    user: {
      ...data,
      profile: {
        ...(state.user?.profile || {}),
        ...data.profile
      }
    }
  }
}
